import { TaskInstance } from "@common/types";

export function isAnyTaskEndState(tasks: TaskInstance[] = []) {
    return tasks?.some(ti => ti?.cv_TaskStatus?.IsEndState) ?? false;
}